const login = {
    name: 'login',
    namespaced: true,
    state: {
        visible: false,
        dialogType: 0
    },
    actions: {
        OpenDialog({ commit }, type) {
            commit('SET_STATE', {
                visible: true,
                dialogType: type
            });
        },
        CloseDialog({ commit }) {
            commit('SET_STATE', {
                visible: false
            });
        }
    }
};

export default login;
